
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnc",
      function () {
        return require("private-next-pages/tnc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnc"])
      });
    }
  